import {
  WasteCollectionAreaAppEntityWasteWasteCollectionAreaRead,
  WasteCollectionScheduleEntryAppEntityWasteWasteCollectionScheduleEntryRead
} from '../../openapi';
import { createReducer, on } from '@ngrx/store';
import {
  loadCollection,
  loadCollectionFailure,
  loadCollectionSuccess,
  loadScheduleEntries,
  loadScheduleEntriesFailure,
  loadScheduleEntriesSuccess
} from '../actions/municipal-waste.actions';

export interface MunicipalWasteState {
  loading: number;
  pending: number;
  collection: WasteCollectionAreaAppEntityWasteWasteCollectionAreaRead[];
  scheduleCollection: WasteCollectionScheduleEntryAppEntityWasteWasteCollectionScheduleEntryRead[];
}

export const initialState: MunicipalWasteState = {
  loading: 0,
  pending: 0,
  collection: [],
  scheduleCollection: []
};

export const municipalWasteReducer = createReducer(
  initialState,
  on(loadCollection, state => ({ ...state, loading: state.loading + 1 })),
  on(loadCollectionSuccess, (state, action) => ({
    ...state,
    loading: state.loading - 1,
    collection: action.collection
  })),
  on(loadCollectionFailure, (state, action) => ({ ...state, loading: state.loading - 1 })),

  on(loadScheduleEntries, (state, action) => ({ ...state, loading: state.loading + 1 })),
  on(loadScheduleEntriesSuccess, (state, action) => ({
    ...state,
    loading: state.loading - 1,
    scheduleCollection: action.scheduleCollection
  })),
  on(loadScheduleEntriesFailure, (state, action) => ({ ...state, loading: state.loading - 1 }))
);
